/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createNewOrganisationDataSchema = z.object({
	name: z.string(),
	website: z.string().url().nullable().optional(),
})

export type CreateNewOrganisationDataSchema = z.infer<typeof createNewOrganisationDataSchema>
